export default {
      id: "sli-circle-check-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.9328ef59.svg#sli-circle-check",
      toString: function () {
        return this.url;
      }
    }